import './busy-panel.scss';
var BusyPanel = /** @class */ /*@__PURE__*/ (function () {
    function BusyPanel() {
    }
    return BusyPanel;
}());
export { BusyPanel };
